// Generates preview HTML for applicant email dialogs (mirrors edge function templates)

const WEBSITE_URL = "https://www.flashtec-solution.de";
const WEBSITE_LABEL = "www.flashtec-solution.de";

function buildWebsiteLine(): string {
  return `<p style="margin: 16px 0;">Mehr über uns erfahren Sie auf unserer Website: <a href="${WEBSITE_URL}" style="color: #1B4D5C; font-weight: bold;">${WEBSITE_LABEL}</a></p>`;
}

function buildFooterHtml(companyName: string, logoUrl?: string, street?: string, houseNumber?: string, postalCode?: string, city?: string, email?: string, phone?: string): string {
  const addressLine = [street, houseNumber].filter(Boolean).join(" ");
  const cityLine = [postalCode, city].filter(Boolean).join(" ");
  const fullAddress = addressLine && cityLine ? `${addressLine}, ${cityLine}` : addressLine || cityLine;

  return `
    <div style="background-color: #1e293b; padding: 24px 32px; border-radius: 0 0 8px 8px;">
      ${logoUrl ? `<img src="${logoUrl}" alt="${companyName}" style="max-height: 32px; max-width: 150px; margin-bottom: 12px; display: block;" />` : ""}
      <p style="color: #e2e8f0; font-size: 14px; font-weight: bold; margin: 0 0 8px 0;">${companyName}</p>
      ${fullAddress ? `<p style="color: #94a3b8; font-size: 12px; margin: 0 0 4px 0;">${fullAddress}</p>` : ""}
      ${phone ? `<p style="color: #94a3b8; font-size: 12px; margin: 0 0 4px 0;">Tel: ${phone}</p>` : ""}
      ${email ? `<p style="color: #94a3b8; font-size: 12px; margin: 0 0 4px 0;"><a href="mailto:${email}" style="color: #94a3b8;">${email}</a></p>` : ""}
      <p style="color: #94a3b8; font-size: 12px; margin: 0;"><a href="${WEBSITE_URL}" style="color: #94a3b8;">${WEBSITE_LABEL}</a></p>
      <hr style="border: none; border-top: 1px solid #334155; margin: 16px 0 8px 0;" />
      <p style="color: #64748b; font-size: 11px; margin: 0;">Diese E-Mail wurde automatisch generiert.</p>
    </div>`;
}

function buildHeaderHtml(title: string, logoUrl?: string, companyName?: string): string {
  return `
    <div style="background-color: #1B4D5C; padding: 20px 32px; border-radius: 8px 8px 0 0;">
      ${logoUrl ? `<img src="${logoUrl}" alt="${companyName || ''}" style="max-height: 48px; max-width: 200px; display: block; margin-bottom: 12px;" />` : ""}
      <h1 style="color: white; margin: 0; font-size: 22px;">${title}</h1>
    </div>`;
}

interface CompanyFooterInfo {
  logoUrl?: string;
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  phone?: string;
}

export function generateRejectionPreviewHtml(
  applicantName: string,
  companyName: string,
  customMessage?: string,
  deleteDocuments?: boolean,
  companyEmail?: string,
  companyInfo?: CompanyFooterInfo,
  futureContact?: boolean
): string {
  return `
    <!DOCTYPE html>
    <html lang="de">
    <head><meta charset="UTF-8"></head>
    <body style="margin: 0; padding: 20px; background-color: #f1f5f9; font-family: Arial, sans-serif;">
      <div style="max-width: 600px; margin: 0 auto;">
        ${buildHeaderHtml("Ihre Bewerbung", companyInfo?.logoUrl, companyName)}
        <div style="background-color: #ffffff; padding: 30px; border: 1px solid #e2e8f0; color: #1e293b;">
          <p>Sehr geehrte/r ${applicantName},</p>
          <p>vielen Dank für Ihr Interesse an einer Tätigkeit bei ${companyName} und die Zeit, die Sie in Ihre Bewerbung investiert haben.</p>
          <p>Nach sorgfältiger Prüfung aller eingegangenen Bewerbungen müssen wir Ihnen leider mitteilen, dass wir uns für andere Kandidaten entschieden haben, deren Profile besser zu den aktuellen Anforderungen passen.</p>
          ${customMessage ? `<p><em>${customMessage}</em></p>` : ''}
          ${futureContact ? `
          <div style="background-color: #eff6ff; padding: 15px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #3b82f6; font-size: 14px;">
            <p style="margin: 0;"><strong>📬 Zukünftige Möglichkeiten</strong></p>
            <p style="margin: 10px 0 0 0;">Sobald bei uns wieder Bedarf in diesem Bereich besteht, würden wir Sie gerne erneut kontaktieren. Falls Sie damit einverstanden sind, antworten Sie bitte kurz auf diese E-Mail mit dem Hinweis, dass wir Ihre Daten für zukünftige Stellenangebote speichern dürfen.</p>
          </div>` : ''}
          <p>Wir möchten uns herzlich für Ihr Interesse an unserem Unternehmen bedanken und wünschen Ihnen für Ihren weiteren beruflichen Werdegang alles Gute und viel Erfolg.</p>
          ${deleteDocuments ? `
          <div style="background-color: #f1f5f9; padding: 15px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #1B4D5C; font-size: 14px;">
            <p style="margin: 0;"><strong>🔒 Datenschutzhinweis (DSGVO)</strong></p>
            <p style="margin: 10px 0 0 0;">Gemäß der Datenschutz-Grundverordnung (DSGVO) werden Ihre Bewerbungsunterlagen und personenbezogenen Daten nach Abschluss des Bewerbungsverfahrens datenschutzkonform gelöscht.</p>
          </div>` : ''}
          ${buildWebsiteLine()}
          <p>Mit freundlichen Grüßen,<br>${companyName}</p>
        </div>
        ${buildFooterHtml(companyName, companyInfo?.logoUrl, companyInfo?.street, companyInfo?.houseNumber, companyInfo?.postalCode, companyInfo?.city, companyEmail, companyInfo?.phone)}
      </div>
    </body>
    </html>`;
}

export function generateInterviewPreviewHtml(
  applicantName: string,
  companyName: string,
  formattedDate: string,
  time: string,
  location: string,
  notes?: string,
  companyEmail?: string,
  companyInfo?: CompanyFooterInfo
): string {
  return `
    <!DOCTYPE html>
    <html lang="de">
    <head><meta charset="UTF-8"></head>
    <body style="margin: 0; padding: 20px; background-color: #f1f5f9; font-family: Arial, sans-serif;">
      <div style="max-width: 600px; margin: 0 auto;">
        ${buildHeaderHtml("Einladung zum Vorstellungsgespräch", companyInfo?.logoUrl, companyName)}
        <div style="background-color: #ffffff; padding: 30px; border: 1px solid #e2e8f0; color: #1e293b;">
          <p>Sehr geehrte/r ${applicantName},</p>
          <p>vielen Dank für Ihre Bewerbung bei ${companyName}. Wir freuen uns, Sie zu einem persönlichen Vorstellungsgespräch einzuladen.</p>
          <div style="background-color: #f8fafc; padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #1B4D5C;">
            <h3 style="margin-top: 0; color: #1e293b;">📅 Terminvorschlag</h3>
            <p style="color: #1e293b;"><strong>Datum:</strong> ${formattedDate}</p>
            <p style="color: #1e293b;"><strong>Uhrzeit:</strong> ${time} Uhr</p>
            <p style="color: #1e293b;"><strong>Ort:</strong> ${location || 'Wird noch bekannt gegeben'}</p>
            ${notes ? `<p style="color: #1e293b;"><strong>Hinweis:</strong> ${notes}</p>` : ''}
          </div>
          <p>Bitte bestätigen Sie diesen Termin oder schlagen Sie uns eine Alternative vor:</p>
          <div style="text-align: center; margin: 30px 0;">
            <span style="display: inline-block; padding: 12px 24px; margin: 10px 5px; border-radius: 6px; font-weight: bold; background-color: #16a34a; color: white;">✓ Termin bestätigen</span>
            <span style="display: inline-block; padding: 12px 24px; margin: 10px 5px; border-radius: 6px; font-weight: bold; background-color: #E5A835; color: white;">Alternative vorschlagen</span>
          </div>
          <p>Sollten Sie Fragen haben, können Sie uns jederzeit kontaktieren.</p>
          ${buildWebsiteLine()}
          <p>Mit freundlichen Grüßen,<br>${companyName}</p>
        </div>
        ${buildFooterHtml(companyName, companyInfo?.logoUrl, companyInfo?.street, companyInfo?.houseNumber, companyInfo?.postalCode, companyInfo?.city, companyEmail, companyInfo?.phone)}
      </div>
    </body>
    </html>`;
}

export function generateOfferPreviewHtml(
  applicantName: string,
  companyName: string,
  position: string,
  formattedSalary: string,
  salaryTypeLabel: string,
  weeklyHours: number,
  vacationDays: number,
  formattedStartDate: string,
  additionalBenefits?: string,
  customMessage?: string,
  companyEmail?: string,
  companyInfo?: CompanyFooterInfo
): string {
  return `
    <!DOCTYPE html>
    <html lang="de">
    <head><meta charset="UTF-8"></head>
    <body style="margin: 0; padding: 20px; background-color: #f1f5f9; font-family: Arial, sans-serif;">
      <div style="max-width: 600px; margin: 0 auto;">
        ${buildHeaderHtml("🎉 Stellenangebot", companyInfo?.logoUrl, companyName)}
        <div style="background-color: #ffffff; padding: 30px; border: 1px solid #e2e8f0; color: #1e293b;">
          <p>Sehr geehrte/r ${applicantName},</p>
          <p>wir freuen uns, Ihnen mitteilen zu können, dass wir Ihnen nach unserem Bewerbungsprozess gerne folgendes Angebot unterbreiten möchten:</p>
          <div style="background-color: white; padding: 25px; border-radius: 8px; margin: 20px 0; border: 2px solid #1B4D5C;">
            <h3 style="margin-top: 0; text-align: center; color: #1B4D5C;">Ihr Angebot bei ${companyName}</h3>
            <div style="display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #e2e8f0;"><span style="color: #64748b;">Position:</span><span style="font-weight: bold; color: #1e293b;">${position}</span></div>
            <div style="display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #e2e8f0;"><span style="color: #64748b;">Gehalt:</span><span style="font-weight: bold; color: #1e293b;">${formattedSalary} ${salaryTypeLabel}</span></div>
            <div style="display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #e2e8f0;"><span style="color: #64748b;">Arbeitszeit:</span><span style="font-weight: bold; color: #1e293b;">${weeklyHours} Stunden/Woche</span></div>
            <div style="display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #e2e8f0;"><span style="color: #64748b;">Urlaubstage:</span><span style="font-weight: bold; color: #1e293b;">${vacationDays} Tage/Jahr</span></div>
            <div style="display: flex; justify-content: space-between; padding: 10px 0;"><span style="color: #64748b;">Startdatum:</span><span style="font-weight: bold; color: #1e293b;">${formattedStartDate}</span></div>
            ${additionalBenefits ? `
            <div style="margin-top: 15px; padding-top: 15px; border-top: 2px solid #e2e8f0;">
              <p style="color: #64748b; margin-bottom: 5px;">Zusätzliche Leistungen:</p>
              <p style="font-weight: bold; color: #1e293b; margin: 0;">${additionalBenefits}</p>
            </div>` : ''}
          </div>
          ${customMessage ? `<div style="background-color: #f0fdf4; padding: 15px; border-radius: 8px; margin: 20px 0;"><p style="margin: 0;"><em>${customMessage}</em></p></div>` : ''}
          <p>Wir würden uns sehr freuen, Sie bald in unserem Team begrüßen zu dürfen.</p>
          <p>Bei Fragen stehen wir Ihnen jederzeit gerne zur Verfügung.</p>
          ${buildWebsiteLine()}
          <p>Mit freundlichen Grüßen,<br>${companyName}</p>
        </div>
        ${buildFooterHtml(companyName, companyInfo?.logoUrl, companyInfo?.street, companyInfo?.houseNumber, companyInfo?.postalCode, companyInfo?.city, companyEmail, companyInfo?.phone)}
      </div>
    </body>
    </html>`;
}
